/**
 * 聚合存储，即一个storage的key下存储一个object，其中包含多个key
 * @param combindKey 聚合key
 * @param key 内部key
 * @param value 内部value
 */
export function saveCombinedValue(
  combindKey: string,
  key: string,
  value: any,
  {
    userId = 0,
    useSessionStorage = false,
  }: {
    userId?: number
    useSessionStorage?: boolean
  } = {},
): void {
  const oldData = getCombinedValue(combindKey, { useSessionStorage });
  const newData = {
    ...oldData,
    [userId]: {
      ...(oldData[userId] || {}),
      [key]: value,
    },
  };
  try {
    if (useSessionStorage) {
      sessionStorage.setItem(combindKey, JSON.stringify(newData));
    } else {
      localStorage.setItem(combindKey, JSON.stringify(newData));
    }
  } catch (e) {
    console.error(e);
  }
}

/**
 * 读取聚合value
 * @param combindKey 聚合key
 * @returns 聚合value
 */
export function getCombinedValue(
  combindKey: string,
  {
    useSessionStorage = false,
  }: {
    useSessionStorage?: boolean
  } = {},
): { [key: string]: any } {
  try {
    const str = useSessionStorage ? sessionStorage.getItem(combindKey) : localStorage.getItem(combindKey);
    if (str) {
      return JSON.parse(str) || {};
    }
  } catch (e) {
    console.error(e);
  }
  return {};
}

/**
 * 从聚合value中取值
 * @param combindKey 聚合key
 * @param key 内部key
 * @param defaultValue 默认值
 * @returns
 */
export function getFromCombinedValue(
  combindKey: string,
  key: string,
  {
    defaultValue = null,
    userId = 0,
    useSessionStorage = false,
  }: {
    defaultValue?: any
    userId?: number
    useSessionStorage?: boolean
  } = {},
): any {
  const data = getCombinedValue(combindKey, { useSessionStorage });
  return data[userId] && data[userId][key] ? data[userId][key] : defaultValue;
}

/**
 * 删除聚合存储子key及对应值
 * @param combindKey 聚合key
 * @param key 内部key
 */
export function removeFromCombinedValue(
  combindKey: string,
  key: string,
  {
    userId = 0,
    useSessionStorage = false,
  }: {
    userId?: number
    useSessionStorage?: boolean
  } = {},
): void {
  const oldData = getCombinedValue(combindKey, { useSessionStorage });
  if (!oldData || !oldData[userId]) return;
  const { [key]: removeKey, ...rest } = oldData[userId] || {};
  const newData = {
    ...oldData,
    [userId]: rest,
  };
  try {
    if (useSessionStorage) {
      sessionStorage.setItem(combindKey, JSON.stringify(newData));
    } else {
      localStorage.setItem(combindKey, JSON.stringify(newData));
    }
  } catch (e) {
    console.error(e);
  }
}
